import request from 'utils/request';
import { isSuccess } from 'utils/utils';

export async function getNowShipOrderDetail (token) {
  const response = await request.getNowShip(
    '/api/booking/sharing/get_detail',
    {
      token,
    },
  );
  if (isSuccess(response)) {
    return response.reply;
  }
  // Error
  window.location.href = '/';
  throw response.result;
}
